/** @file nodeTargets: the nodes a node menu acts on (the selection when it holds the node). */
import type { NodeMenuCtx } from './registryTypes';

/** Right-clicking a selected joint acts on the selection; right-clicking any other node acts on that node alone. */
export function nodeTargets(ctx: Pick<NodeMenuCtx, 'store' | 'node'>): string[] {
  const selected = ctx.store.getState().selection.nodes;
  return selected.includes(ctx.node) ? selected : [ctx.node];
}
